module.exports = __webpack_public_path__ + "pc/img/huawei.a056a352.jpg";